export default {
  base_url: '/api/illustrator/profile/portfolio/image-set/images',
  store_cover_image_url: '/api/illustrator/profile/portfolio/image-set/image-sets/store-cover-image',
  replace_image_set_image_url: '/api/illustrator/profile/portfolio/image-set/replace-image',
  image_sets_base_url: '/api/illustrator/profile/portfolio/image-set/image-sets',

  updateImageSetImages(form, id) {
    return form.put(`${this.image_sets_base_url}/${id}/update-images`);
  },

  remove(id) {
    return axios.delete(`${this.base_url}/${id}`).then(response => response.data);
  },

  changeOrder(id, imageSetImageIds) {
    return new Promise((resolve, reject) => {
      return axios.put(`${this.image_sets_base_url}/${id}/images/reorder`, {image_set_image_ids: imageSetImageIds}).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
};